// extracted by mini-css-extract-plugin
export default {"expired-tag":"CertificateStatusTag_expired-tag__8i8Am","active-tag":"CertificateStatusTag_active-tag__bGV-6"};